import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import React from 'react';
import { css, px, remove as removeCss } from '@jd/jmtd-tools/es/css';
import { isNumber } from '@jd/jmtd-tools/es/is';
import { repeat, take } from '@jd/jmtd-tools/es/generator';
import { setClass } from '@jd/jmtd-tools/es/element';
import { SCROLL_CONTENT, TabsScrollContext } from '../Tabs/util';
export default function CardTabs(self) {
  var _TabsScrollContext = TabsScrollContext({
    self: self,
    margin: -1,
    getTabsWidth: function getTabsWidth() {
      var tabsRef = self.tabsRef,
          full = self.props.full,
          ref = self.ref;
      var tabsWidth = tabsRef.map(function (node) {
        return node.offsetWidth;
      });

      if (full == null) {
        return tabsWidth;
      }

      var itemWidth = isNumber(full) ? Math.max.apply(Math, [Math.floor((ref.offsetWidth - 40) / full)].concat(_toConsumableArray(tabsWidth))) : Math.max.apply(Math, _toConsumableArray(tabsWidth));
      return _toConsumableArray(take(tabsWidth.length, repeat(itemWidth)));
    },
    handleScroll: function handleScroll(_ref) {
      var currentMatch = _ref.currentMatch,
          maxScrollWidth = _ref.maxScrollWidth,
          matchedWidth = _ref.matchedWidth,
          tabsWidth = _ref.tabsWidth;
      var tabsRef = self.tabsRef,
          _self$props = self.props,
          full = _self$props.full,
          placeholder = _self$props.placeholder;
      tabsRef.forEach(function (tab) {
        removeCss(tab, ['flex', 'max-width']);
      }); // 有滚动

      // 有滚动
      if (currentMatch.length < tabsRef.length) {
        var remindExtra = maxScrollWidth - matchedWidth + Math.max(currentMatch.length - 1, 0);
        var itemMargin = Math.round(remindExtra / currentMatch.length);
        var matchedSet = new Set(currentMatch);
        currentMatch.forEach(function (index) {
          css(tabsRef[index], 'width', px(tabsWidth[index] + Math.min(remindExtra, itemMargin)));
          remindExtra -= itemMargin;
        });
        tabsRef.forEach(function (tab, index) {
          setClass(tab, 'jmtd-tabs-tab-off-screen', !matchedSet.has(index));
        });
      } else if (full) {
        var length = placeholder && isNumber(full) ? full : tabsRef.length;
        var percent = "".concat((100 / length).toFixed(7), "%");
        tabsRef.forEach(function (tab) {
          tab.classList.remove('jmtd-tabs-tab-off-screen');
          removeCss(tab, 'width');
          css(tab, {
            flex: "0 0 ".concat(percent),
            'max-width': percent
          });
        });
      } else {
        tabsRef.forEach(function (tab, index) {
          tab.classList.remove('jmtd-tabs-tab-off-screen');
          css(tab, 'width', px(tabsWidth[index]));
        });
      }
    }
  }),
      _update = _TabsScrollContext.update,
      arrowLeft = _TabsScrollContext.arrowLeft,
      arrowRight = _TabsScrollContext.arrowRight;

  return {
    className: function className() {
      var full = self.props.full;
      return {
        'jmtd-card-tabs': true,
        'jmtd-card-tabs-full': full != null
      };
    },
    update: function update() {
      _update(self.activeIndex);
    },
    render: function render(tabs) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, arrowLeft, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-tabs-scroll-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-tabs-scroll-content",
        ref: function ref(el) {
          self[SCROLL_CONTENT] = el;
        }
      }, tabs)), arrowRight, /*#__PURE__*/React.createElement("div", {
        className: "jmtd-tabs-border"
      }));
    }
  };
}